import React, { useMemo } from 'react';
import { Search, PlusCircle } from 'lucide-react';

export default function AddProjectSection({
  templates, // Array of template file objects
  templateSearchQuery,
  onSearchChange, // Function to update search query in parent state
  onAddProject, // Function to trigger adding project
  isLoading, // Boolean indicating if templates are loading
  addingProjectId // ID of the template currently being added
}) {

  // Filter templates based on search query
  const filteredTemplates = useMemo(() => {
    if (!Array.isArray(templates)) {
      return [];
    }
    if (!templateSearchQuery) {
      return templates;
    }
    const query = templateSearchQuery.toLowerCase().trim();
    return templates.filter(templateFile => {
      if (!templateFile || !templateFile.id) return false;
      const fileNameMatch = (templateFile.fileName?.toLowerCase() || '').includes(query);
      const docTitleMatch = (templateFile.docTitle?.toLowerCase() || '').includes(query);
      const collectionNameMatch = (templateFile.collectionName?.toLowerCase() || '').includes(query);
      return fileNameMatch || docTitleMatch || collectionNameMatch;
    });
  }, [templates, templateSearchQuery]);

  return (
    <div className="add-template-section">
      <h3 className="section-title">Dodaj nowy projekt z szablonu</h3>
      <div className="template-search-container">
        <Search size={18} className="search-icon" />
        <input
          type="text"
          placeholder="Wyszukaj szablon po nazwie lub kolekcji..."
          value={templateSearchQuery}
          onChange={(e) => onSearchChange(e.target.value)} // Use callback
          className="template-search-input"
        />
      </div>

      {isLoading ? (
        <p className="loading-text">Ładowanie szablonów...</p>
      ) : templates.length === 0 ? (
        <p>Brak dostępnych szablonów.</p>
      ) : filteredTemplates.length === 0 ? (
        <p>Nie znaleziono szablonów pasujących do zapytania.</p>
      ) : (
        <ul className="template-list">
          {filteredTemplates.map(templateFile => (
            <li key={templateFile.id} className="template-list-item">
              <span className="template-name">
                {templateFile.docTitle || templateFile.fileName}
                {templateFile.collectionName && <span style={{ color: '#888', marginLeft: '8px', fontSize: '0.9em' }}>({templateFile.collectionName})</span>}
              </span>
              <button
                className="admin-btn-icon admin-btn-icon-add"
                onClick={() => onAddProject(templateFile.id)} // Use callback
                disabled={addingProjectId === templateFile.id}
                title="Dodaj ten projekt z szablonu do zamówienia"
              >
                {addingProjectId === templateFile.id ? (
                  <div className="popup-spinner popup-spinner-button"></div> // Assuming CSS exists
                ) : (
                  <PlusCircle size={16} />
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
